import { FC } from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@capacit-com/lara-law-shared-ui";
import HubSpotForm from "@/components/hubspot/HubSpotForm";

interface SupportModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

const SupportModal: FC<SupportModalProps> = ({ open, onOpenChange }) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent size="lg">
        <DialogHeader>
          <DialogTitle>Support</DialogTitle>
          <DialogDescription>
            Udfyld formularen nedenfor for at kontakte support.
          </DialogDescription>
        </DialogHeader>
        <div className="mt-4">
          <HubSpotForm />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default SupportModal;
